module.exports = __webpack_public_path__ + "img/拳头.40955a90.png";